import * as React from 'react';

import * as moment from 'moment-timezone';
import TimePicker from 'components/time_picker';
import DatePicker from 'components/date_picker';

interface DateTimePickerState {
  date: moment.Moment;
}

interface DateTimePickerProps {
  timezone: string;
  timezoneDisplay: string;
}

export default class DateTimePicker extends React.PureComponent<
  DateTimePickerProps,
  DateTimePickerState
> {
  static defaultProps = {
    timezone: 'UTC',
    timezoneDisplay: 'UTC',
  };

  constructor(props: DateTimePickerProps) {
    super(props);
    const now = moment().tz(props.timezone);
    this.state = { date: now };
  }

  updateDate = (date: moment.Moment) => {
    this.setState({ date: date.tz(this.props.timezone) });
  };

  render() {
    return (
      <div className="date-time-picker row">
        <div className="backfill-date-picker span6">
          <DatePicker
            onChange={this.updateDate}
            selectedDate={this.state.date}
            disabled={false}
          />
        </div>
        <div className="backfill-time-picker span6">
          <TimePicker
            onChange={this.updateDate}
            selectedDate={this.state.date}
            disabled={false}
          />
        </div>
        <input
          type="hidden"
          name="incident[backfill_date]"
          value={this.state.date.toISOString()}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/components/backfill_date_time_picker/index.tsx